module.exports = __webpack_public_path__ + "3904a2cfdbcb7e4edd978d073df07257.pdf";